import { useAtomValue } from 'jotai'
import React from 'react'

import { hiddenSurveyIdsAtom } from '../atoms'

import { useCurrentSurveys } from './useCurrentSurveys'

export const useVisibleSurveys = () => {
  const surveys = useCurrentSurveys()
  const hiddenSurveyIds = useAtomValue(hiddenSurveyIdsAtom)

  return React.useMemo(
    () => surveys.filter((survey) => !hiddenSurveyIds.includes(survey.id)),
    [hiddenSurveyIds, surveys],
  )
}
